<template>
  <div class="hd-web">
    <!-- 头部 -->
    <hd-header></hd-header>
    <section class="hd-web-content">
      <!-- 首页Banner-->
      <section class="banner">
        <div class="wrap">
          <div class="content clear">
            <div class="app">
              <div class="sliderContainer">
                <slider width="192px" height="338px" :interval="3000" :speed="500" :control-btn="false">
                  <slider-item>
                    <img src="~assets/images/img-1.png" alt="">
                  </slider-item>
                  <slider-item>
                    <img src="~assets/images/img-2.png" alt="">
                  </slider-item>
                  <slider-item>
                    <img src="~assets/images/img-3.png" alt="">
                  </slider-item>
                  <slider-item>
                    <img src="~assets/images/img-4.png" alt="">
                  </slider-item>
                </slider>
              </div>
            </div>
            <div class="text">
              <h1>海渡职校APP</h1>
              <p>颠覆传统课堂学习，您身边的机器人学院。</p>
              <a href="javascript:;" class="button" onclick="javascript:document.getElementById('download').scrollIntoView()">
                <i class="icon"></i>APP下载</a>
            </div>
          </div>
        </div>
      </section>
      <!-- 学习资源 -->
      <section class="page">
        <div class="wrap">
          <h1 class="title">专业的工业机器人学习资源只在
            <span style="color: #24b2f9;">海渡职校</span>
          </h1>
          <div class="line"></div>
          <div class="content clear">
            <div class="item">
              <img src="../assets/images/icon_shuji.png" alt="">
              <h3>专业的配套教材</h3>
              <p>机器人领域专家教师及职业教育领域优秀教师潜心编纂。</p>
              <p>工业机器人技术专业 “十三五” 规划教材</p>
              <p>工业机器人应用人才培养指定用书</p>
            </div>
            <div class="item">
              <img src="../assets/images/icon_live.png" alt="">
              <h3>丰富的视频教学资源</h3>
              <p>行业资深高级工程师现场录制</p>
              <p>结合实物装备，针对知识点细化分解</p>
            </div>
          </div>
        </div>
      </section>
      <!-- 独一无二 -->
      <section class="page" style="background-color: #f4f8fb;padding-bottom: 90px;">
        <div class="wrap">
          <h1 class="title">全网独一无二</h1>
          <div class="line"></div>
          <h3 class="tip">免费优质课程、专注工业机器人教育；工业机器人学习从入门到精通</h3>
          <div class="content">
            <img src="../assets/images/img_duyiwuer.png" alt="">
            <p class="sys-up">系统式进阶成长</p>
            <p class="ln-plat">首款机器人学习平台</p>
            <p class="dis">名校零距离</p>
          </div>
        </div>
      </section>
      <!-- 学习体验-->
      <section class="page">
        <div class="wrap">
          <div class="content clear">
            <div class="text">
              <h1>全新学习体验</h1>
              <div class="line" style="margin-left: 0;"></div>
              <p>
                <span class="bold">更新的学习方式：</span>
                <span>提供工业机器人领域轻量学习内容</span>
                <br>
                <span>每一块碎片时间都可以被更好地利用</span>
              </p>
              <p>
                <span class="bold">更快的成长路径：</span>
                <span>除了轻量学习内容，还有更为丰富</span>
                <br>
                <span>的进阶式学习系统，工业机器人学习，拾级而上</span>
              </p>
              <p>
                <span class="bold">更好的学习效果：</span>
                <span>结合个性推荐、学习任务管理等多</span>
                <br>
                <span>项功能、帮助你有效提升学习效果，成就机器人指挥官</span>
              </p>
            </div>
            <div class="image">
              <img src="../assets/images/img_xuexitiyan.png" alt="">
            </div>
          </div>
        </div>
      </section>
      <!-- 签到送积分-->
      <section class="page" style="background-color: #f4f8fb;padding-bottom: 90px;">
        <div class="wrap">
          <div class="content clear">
            <div class="image" style="margin-right: 30px;width: 450px;">
              <img src="../assets/images/img_qiandao.png" alt="">
            </div>
            <div class="text" style="width: auto;margin-right: 0;">
              <h1>签到送积分，自由兑换书籍和教学资源</h1>
              <div class="line" style="margin-left: 0;"></div>
              <p>签到都有积分送，连续签到更有玫瑰和游轮</p>
              <p style="margin-top: 5px;">邀请好友送400积分，8个好友加入就能免费得书籍</p>
            </div>
          </div>
        </div>
      </section>
      <!-- 下载部分-->
      <section id="download" class="download-area">
        <div class="wrap">
          <h1>根据您的手机，选择下载</h1>
          <div class="content clear">
            <div class="buttons">
              <a href="https://itunes.apple.com/us/app/%E6%B5%B7%E6%B8%A1%E5%AD%A6%E9%99%A2/id1249979481?ls=1&mt=8" class="iphone">iPhone版本下载</a>
              <a href="http://sj.qq.com/myapp/detail.htm?apkName=com.haidu.academy" class="android">Android版本下载</a>
            </div>
            <div class="code">
              <img src="http://edubot-1252617679.picsh.myqcloud.com/2017_08_09_1606309518.png" alt="">
              <p>扫一扫下载APP</p>
            </div>
          </div>
        </div>
      </section>
      <hd-footer></hd-footer>
    </section>
  </div>
</template>
<script>
import {
  Slider,
  SliderItem
} from 'vue-easy-slider'
import hdHeader from '@/components/layout/hd-header'
import hdFooter from '@/components/layout/hd-footer'
export default {
  data () {
    return {}
  },
  components: {
    hdHeader,
    hdFooter,
    Slider,
    SliderItem
  }
}

</script>
<style lang="scss" scoped>
.hd-web-content {
  position: relative;
  top: 72px;
}

.banner {
  width: 100%;
  height: 565px;
  position: relative;
  background: url(~assets/images/banner_bg.png) center no-repeat;
  background-size: cover;
  .content {
    width: 860px;
    margin: 0 auto;
    padding-top: 52px;
    display: flex;
    .app {
      width: 226px;
      height: 453px;
      background: url(../assets/images/img_shoujike.png) center no-repeat;
      float: left;
      position: relative;
      background-size: contain;
      .sliderContainer {
        position: absolute;
        width: 191px;
        height: 338px;
        left: 17px;
        top: 57px;
      }
    }
    .text {
      margin-left: auto;
      color: #fff;
      padding-top: 65px;
      float: right;
      h1 {
        font-size: 40px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .button {
        width: 191px;
        height: 48px;
        background: #fff;
        color: #119fed;
        border-radius: 48px;
        text-align: center;
        margin-top: 62px;
        padding-left: 30px;
        font-size: 20px;
        position: relative;
        display: block;
        line-height: 48px;
        .icon {
          display: block;
          width: 28px;
          height: 28px;
          background: url(../assets/images/icon_xiazai.png) center no-repeat;
          position: absolute;
          left: 32px;
          top: 10px;
        }
      }
    }
  }
}

.page {
  width: 100%;
  padding-top: 80px;
  padding-bottom: 130px;
  .title {
    font-size: 30px;
    text-align: center;
    color: #333333;
  }
  .line {
    width: 118px;
    background: #000;
    height: 2px;
    margin: 20px auto 0;
  }
  .content {
    display: flex;
    position: relative;
    .item {
      text-align: center;
      margin-top: 90px;
      margin-right: 115px;
      color: #333333;
      font-size: 16px;
      float: left;
      img {
        width: 178px;
        margin-bottom: 45px;
      }
      h3 {
        color: #333333;
        font-size: 24px;
        margin-bottom: 20px;
      }
      p {
        margin-top: 10px;
        color: #666666;
        font-size: 16px;
      }
    }
    .text {
      width: 390px;
      padding-top: 140px;
      text-align: left;
      margin-right: 75px;
      float: left;
      & > h1 {
        color: #333333;
        font-size: 30px;
      }
      & > p {
        margin-top: 20px;
        color: #666666;
        line-height: 1.5;
        font-size: 16px;
        .bold {
          font-weight: bold;
        }
      }
    }
    .image {
      width: 530px;
      float: left;
    }
  }
  .tip {
    color: #666666;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 65px;
    font-size: 16px;
  }
  .sys-up {
    position: absolute;
    bottom: 20%;
    left: 10%;
  }
  .ln-plat {
    position: absolute;
    bottom: 18%;
    left: 40%;
    font-size: 24px;
    color: #333333;
  }
  .dis {
    position: absolute;
    bottom: 20%;
    left: 78%;
  }
}

.download-area {
  width: 100%;
  background: url(../assets/images/img_xiazaibg.png) top no-repeat;
  background-color: #0f9eec;
  background-size: contain;
  padding: 110px 0 191px 0;
  box-sizing: border-box;
  h1 {
    font-size: 30px;
    color: #fff;
    text-align: center;
  }
  .content {
    display: flex;
    align-items: center;
    margin-top: 78px;
    width: 515px;
    margin: 78px auto;
    .buttons {
      margin-right: 32px;
      float: left;
      & > a {
        display: block;
        width: 250px;
        height: 58px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        line-height: 58px;
        border-radius: 10px;
        position: relative;
        padding-left: 20px;
        box-sizing: border-box;
        font-size: 20px;
        &:before {
          content: '';
          width: 29px;
          height: 36px;
          display: block;
          position: absolute;
          top: 11px;
          left: 20px;
        }
      }
      .iphone {
        background: #00ceff;
        &:before {
          background: url(../assets/images/icon_ios.png) center no-repeat;
        }
      }
      .android {
        background: #00da81;
        margin-top: 25px;
        &:before {
          background: url(../assets/images/icon_anzuo.png) center no-repeat;
        }
      }
    }
    .code {
      background-color: #fff;
      padding: 36px 36px 20px;
      color: #0f9eec;
      float: left;
      text-align: center;
      & > p {
        font-size: 20px;
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?2d6270fc